class CollectionHighlightCarousel extends HTMLElement {

  constructor() {
    super()
    this.els = {
      slides: this.querySelector('[data-collection-highlight-carousel-el="slides"]'),
      slide: this.querySelectorAll('[data-collection-highlight-carousel-el="slide"]'),
    }
  }

  connectedCallback () {
    if (this.els.slide.length < 2) return

    this.setupCarousel()
  }

  setupCarousel () {
    const autoplaySpeed = this.dataset.autoplaySpeed ? parseInt(this.dataset.autoplaySpeed) : 5000

    const prefersReducedMotion = window.matchMedia(
      '(prefers-reduced-motion: reduce)',
    ).matches

    if (prefersReducedMotion) {
      this.els.slides.setAttribute('data-reduced-motion', 'true')
      return
    }

    const slidesArray = Array.from(this.els.slide)
    const numberOfSlides = slidesArray.length

    slidesArray.forEach(slide => {
      const clone = slide.cloneNode(true)
      this.els.slides.appendChild(clone)
    })

    const initAnimation = () => {
      const totalWidth = this.els.slides.scrollWidth
      const scrollDistance = totalWidth / 2

      const animationDuration = autoplaySpeed * numberOfSlides

      this.els.slides.style.setProperty('--animation-duration', `${animationDuration}ms`)
      this.els.slides.style.setProperty('--scroll-distance', `-${scrollDistance}px`)
      this.els.slides.setAttribute('data-initialised', 'true')
    }

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        setTimeout(initAnimation, 100)
      })
    })
  }
}

if (!customElements.get('collection-highlight-carousel')) {
  customElements.define('collection-highlight-carousel', CollectionHighlightCarousel)
}
